<script setup lang="ts">
</script>

<template>
    <UMain class="min-h-screen w-full">
        <slot />
    </UMain>
</template>

<style>
html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}
</style>
